"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 15 15';

var RadioButtonOn = function RadioButtonOn(_ref) {
  var classes = _ref.classes;
  return _react["default"].createElement("g", {
    transform: "translate(0, 0.5)"
  }, _react["default"].createElement("path", {
    className: classes.border,
    d: "M7.1375,0 C3.195,0 0,3.1955 0,7.137 C0,11.0795 3.195,14.275 7.1375,14.275 C11.0795,14.275 14.2745,11.0795 14.2745,7.137 C14.2745,3.1955 11.0795,0 7.1375,0 M7.1375,1.115 C10.458,1.115 13.1595,3.8165 13.1595,7.137 C13.1595,10.458 10.458,13.1595 7.1375,13.1595 C3.8165,13.1595 1.115,10.458 1.115,7.137 C1.115,3.8165 3.8165,1.115 7.1375,1.115"
  }), _react["default"].createElement("path", {
    d: "M7.1375,11.476 C9.478,11.476 11.3755,9.5785 11.3755,7.2375 C11.3755,4.8975 9.478,3 7.1375,3 C4.7965,3 2.899,4.8975 2.899,7.2375 C2.899,9.5785 4.7965,11.476 7.1375,11.476"
  }));
};

RadioButtonOn.propTypes = {
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired
};
var StyledRadioButtonOn = (0, _withStyles["default"])({
  border: {
    fill: _styles.colors.gray
  }
})(RadioButtonOn);

var _default = (0, _createSvgIcon["default"])(StyledRadioButtonOn, {
  viewBox: viewBox
});

exports["default"] = _default;